import React from 'react';

import PropTypes from 'prop-types';
import { flexRender } from '@tanstack/react-table';

import { TableHead, TableRow } from '@/components/ui/table';

const Header = ({ headerGroup }) => (
  <TableRow>
    {headerGroup.headers.map((header) => (
      <TableHead className={header.column.columnDef.meta?.className} key={header.id}>
        {header.isPlaceholder
          ? null
          : flexRender(header.column.columnDef.header, header.getContext())}
      </TableHead>
    ))}
  </TableRow>
);

Header.propTypes = {
  headerGroup: PropTypes.shape({
    headers: PropTypes.arrayOf(
      PropTypes.shape({
        getContext: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        isPlaceholder: PropTypes.bool,
        column: PropTypes.shape({
          columnDef: PropTypes.shape({
            header: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
          }).isRequired,
        }).isRequired,
      })
    ).isRequired,
  }).isRequired,
};

export default Header;
